<template>
  <div>
    <!-- <div class="searchbox" :class="{'hascity':allEstate||saleEstate}"> -->
    <div class="searchbox" :class="{'sb_mtx':logoIndex==1,'sb_ml':logoIndex==2,'sb_zmf':logoIndex==3,'sb_mdr':logoIndex==4}">
      <!-- <el-dropdown trigger="click">
        <span>{{storage.get('city').city}}<i class="m-icon mi-dropdown"></i></span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :key="index" v-for="(item,index) in cityItems" @click.native="changeCity(item)">{{item.city}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
      <i class="m-icon mi-search" :class="{'mi_mtx':logoIndex==1,'mi_ml':logoIndex==2,'mi_zmf':logoIndex==3,'mi_mdr':logoIndex==4}" @click="search()"></i>
      <form action="javascript:true">
        <input class="sinput" ref="inputText" type="text" placeholder="请输入楼盘名称或区域" v-focus="!(allEstate||saleEstate)" v-model="keyword">
      <img src="../../../static/estate_mtxlogo.png" class="logo_mtx" v-if="logoIndex==1">
      <img src="../../../static/estate_mllogo.png" class="logo_ml" v-if="logoIndex==2">
      <img src="../../../static/estate_zmflogo.png" class="logo_zmf" v-if="logoIndex==3">
      <img src="../../../static/estate_mdrlogo.png" class="logo_mdr" v-if="logoIndex==4">
      </form>
      <span class="cancle" @click="$router.push({path:'/'})">取消</span>
      <i class="m-icon mi-home" @click="$router.push({path:'/'})"></i>
    </div>
    <div class="hotkey" v-if="showHot&&!allEstate&&!saleEstate">
      <p>热门搜索</p>
      <span :key="index" v-for="(item,index) in tagItems" @click="hotClick(item.pkId)">{{item.name}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchInput',
  inject:['reload'],
  props:{
    allEstate:Boolean,
    saleEstate:Boolean,
    kword:String
  },
  data () {
    return {
      cityItems:this.storage.get('cityItems'),
      tagItems:[],
      keyword:this.kword,
      showHot:1,
      logoIndex: this.$store.state.domainIndex, 
    }
  },
  directives:{
    focus:{
      inserted:function(el,{value}){
        if(value){
          el.focus();
        }
      }
    }
  },
  mounted(){
    var _this = this;

    _this.getHotKey();
  },
  created(){
    var _this = this;
    document.onkeydown = function(e) {
      var key = window.event.keyCode;
      if (key == 13) {
        _this.search();
      }
    }
  },
  methods:{
    changeCity:function(city){
           
      this.storage.set('city',city);
      var domain = window.location.hostname;
      var pathname = window.location.pathname;
      
      //wap
     if(domain.indexOf('m.')>-1){
        pathname = pathname.split('/');
        window.open(window.location.protocol+'//'+domain+'/'+ city.cityCode +'/'+ pathname[2], '_self');
        return false;
     }

      //也跳wap
     if(domain.indexOf('www.')>-1){
         //取跟路径下第一个斜杠后的城市简称
          pathname = pathname.split('/');
          window.open(window.location.protocol+'//'+domain+'/'+ city.cityCode +'/'+ pathname[2], '_self');
         return false;
    }
      //PC
      if(domain.indexOf('m.')==-1 && domain.indexOf('www.')==-1){
         domain = domain.substr(domain.indexOf('.')+1,domain.length);
        window.open(window.location.protocol+'//'+city.cityCode+'.'+domain + pathname, '_self')
        return false;
     }
     // this.reload();
    },
    getHotKey:function(){
      this.$http.get('/api/index/getHotSearch').then((response)=>{
        this.tagItems = response.data.result
      }).catch((response)=>{
        console.log(response)
      })
    },
    search:function(){
      this.showHot=0;
      this.keyword==undefined?this.keyword='':'';
      this.$emit('getKeyword',this.keyword);
    },
    hotClick:function(id){
      this.$router.push({path:'/estateDetail?estateId='+id});
    },
  }
}
</script>

<style scoped>
.searchbox .logo_mtx{width:94px;height:auto;position:absolute;left:10px;top:13px;z-index:1;}
.searchbox .logo_ml{width:88px;height:auto;position:absolute;left:10px;top:10px;z-index:1;}
.searchbox .logo_zmf{width:98px;height:auto;position:absolute;left:10px;top:11px;z-index:1;}
.searchbox .logo_mdr{width:98px;height:auto;position:absolute;left:10px;top:11px;z-index:1;}
.searchbox{background:#fff;padding:10px 55px 10px 15px;height:34px;}
.searchbox .el-dropdown{display:none;}
.sinput{display:block;background:#f1f0ee;height:34px;line-height:18px;padding:9px 15px 8px 40px;border-radius:20px;border:0;width:100%;box-sizing:border-box;outline:none;font-size:14px;}
.mi-search{position:absolute;left:31px;top:19px;background-position:0 0;width:17px;height:17px;}
.cancle{color:#999;position:absolute;right:15px;top:18px;line-height:18px;}
.hascity{padding-right:50px;}
.hascity .cancle{display:none;}
.hascity .mi-home{width:19px;height:19px;background-position:-162px -79px;position:absolute;top:18px;right:16px;opacity:0.7;}
.hascity .sinput{padding-left:102px;}
.hascity .mi-search{left:93px;}
.hascity .el-dropdown{position:absolute;left:31px;top:17px;display:inline-block;color:#333;}
.hascity .el-dropdown:after{content:"";position:absolute;right:-11px;top:0;bottom:0;border-left:1px solid #999;}
.mi-dropdown{width:7px;height:4px;background-position:-147px 0;margin:6px 0 0 5px;}
.el-dropdown-menu{width:372px;left:15px!important;padding:10px;box-sizing:border-box;}
.el-dropdown-menu__item{display:inline-block;width:70px;padding:0;text-align:center;}

.hotkey{padding:15px 25px 15px 15px;line-height:28px;color:#666;}
.hotkey p{padding-left:10px;}
.hotkey span{display:inline-block;padding:1px 12px 0;border-radius:32px;border:1px solid #ddd;margin-top:10px;margin-left:10px;background:#fff;text-align:center;font-size:12px;}

.sb_mtx{padding-left:114px}
.sb_ml{padding-left:108px}
.sb_zmf{padding-left:118px}
.sb_mdr{padding-left:118px}
.mi_mtx{left:124px}
.mi_ml{left:118px}
.mi_zmf{left:128px}
.mi_mdr{left:128px}
@media (max-width:420px){
  .el-dropdown-menu{left:5%!important;width:90%;}
  .el-dropdown-menu__item{width:25%;}
}
</style>



// WEBPACK FOOTER //
// src/components/public/SearchInput.vue